import styled from '@emotion/styled';
import {
  mainFontFamily,
  displayFontFamily,
  mediaBreakpointUpMD,
  ssColorCyan,
  ssColorMidGrey,
  ssColorMidBlueGrey,
  ssColorWhite,
} from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';

export const Paragraph = styled.p`
  font-family: ${mainFontFamily};
  font-size: 1rem;
  margin: 0.5rem 0;
  color: ${props => (props.faded ? ssColorMidBlueGrey : ssColorWhite)};
`;

export const BoldParagraph = styled(Paragraph)`
  font-weight: normal;
`;

export const Subtitle = styled.p`
  font-family: ${mainFontFamily};
  letter-spacing: 0.5px;
  margin: 0.5rem 0;
  font-size: 1.3rem;
`;

export const Subtext = styled.span`
  font-size: 0.8rem;
`;

export const DataDescription = styled.p`
  /* stylelint-disable string-quotes */
  /* stylelint-disable declaration-colon-newline-after */
  /* stylelint-disable indentation */
  font-size: ${(props) => {
    if (props.large) return '0.9rem';
    if (props.small) return '0.6rem';
    return '0.7rem';
  }};
  color: ${props => (props.light ? ssColorWhite : ssColorMidBlueGrey)};
  text-transform: uppercase;
  ${props => props.flush && `
    margin-bottom: 0
  `}
`;

export const DisplayHeader = styled.h1`
  font-family: ${displayFontFamily};
  color: ${ssColorCyan};
  letter-spacing: 0.5px;
  margin: 0.5rem 0;
  font-size: 2.8rem;

  ${mediaBreakpointUpMD} {
    font-size: 3.5rem;
  }
`;

export const Header2 = styled.h2`
  color: inherit;
`;

export const Header3 = styled.h3`
  color: inherit;
`;

export const Header4 = styled.h4`
  color: inherit;
  /* stylelint-disable-next-line font-family-name-quotes */
  font-family: ${props => props.displayFont && displayFontFamily};
`;

export const BigNumber = styled.p`
  font-family: ${mainFontFamily};
  /* stylelint-disable-next-line font-weight-notation */
  font-weight: 400;
  font-size: 2.8rem;
  margin-bottom: 0;
  line-height: 1.1;

  span {
    font-size: 1.5rem;
    vertical-align: super;
    margin: ${vunit(0.5)};
  }
`;

export const Tag = styled.div`
  display: inline-block;
  text-transform: uppercase;
  color: ${ssColorMidGrey};
  letter-spacing: 1.5px;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: ${vunit(1)};
  margin-top: ${vunit(3)};
`;
